<template>
  <div class="page-shell page-shell--accesskey">
    <section class="page-shell__content">
      <div class="page-shell__panel">
        <div class="page-shell__panel-header">
          <div>
            <div class="page-shell__panel-title">密钥列表</div>
            <div class="page-shell__panel-subtitle">
              AccessKey 用于 Rainbond 等客户端连接应用市场时的身份校验。
            </div>
          </div>
        </div>
        <public-table
          v-loading="listLoading"
          :column="column"
          :tableData="accesskeys"
          :PageInfo="listQuery"
          :is_table="true"
          :onAdd="
            () => {
              (accessKey = null), (showAdd = true);
            }
          "
          addPerm="Enterprise.AccessKey.Create"
          @handlePaginationChange="getAccessKeyList"
        >
          <template v-slot:createTime="{ row }">
            {{
            row.createTime ? timetrans(row.createTime) : "-"
            }}
          </template>
          <template v-slot:expiredTime="{ row }">
            {{
            row.expiredTime ? showExpiredTime(row) : "不过期"
            }}
          </template>
          <template v-slot:actions="{ row }">
            <el-tag
              style="margin-left:8px"
              v-for="item in row.actions"
              :key="item"
              type="warning"
              size="mini"
            >{{ actionShow[item] }}</el-tag>
          </template>
          <template v-slot:accessKeyID="{ row }">
            <el-button
              v-permit="'Enterprise.AccessKey.Delete'"
              size="mini"
              type="text"
              @click="deleteAccessKey(row)"
            >删除</el-button>
            <el-button
              v-permit="'Enterprise.AccessKey.ReGenerate'"
              size="mini"
              type="text"
              @click="updateAccessKey(row)"
            >更新</el-button>
          </template>
        </public-table>
      </div>
    </section>

    <create-key
      :eid="eid"
      :accessKey="accessKey"
      :openMarket="openMarket"
      :dialogVisible="showAdd"
      :onSuccess="createSuccess"
      :onClose="() => (showAdd = false)"
    ></create-key>
  </div>
</template>
<script>
import { timetrans } from '@/utils/validate';
import {
  fetchAccessToken,
  deleteAccessKeyApi,
  updateAccessKeyApi
} from '@/api/enterpriseManage';
import { errorHandle } from '@/utils/error';
import CreateKey from './components/add';
import { havePerm } from '@/utils/auth';
import moment from 'moment';

const defaultListQuery = {
  page: 1,
  size: 10
};

export default {
  name: 'AccessKey',
  components: {
    'create-key': CreateKey
  },
  data() {
    return {
      havePerm,
      customerForm: {
        type: 'all'
      },
      listQuery: Object.assign({}, defaultListQuery),
      accesskeys: [],
      accessKey: null,
      listLoading: true,
      showAdd: false,
      timetrans: timetrans,
      editCustomer: {},
      showEditCustomer: false,
      actionShow: {
        OnlyRead: '只读',
        ReadInstall: '安装应用',
        Write: '推送应用'
      },
      column: [
        {
          prop: 'note',
          label: '使用说明'
        },
        {
          prop: 'createTime',
          label: '创建时间',
          scopeStatus: true
        },
        {
          prop: 'expiredTime',
          label: '过期时间',
          scopeStatus: true
        },
        {
          prop: 'actions',
          label: '权限',
          scopeStatus: true
        },
        {
          prop: 'accessKeyID',
          label: '操作',
          scopeStatus: true
        }
      ]
    };
  },
  created() {
    this.getAccessKeyList();
  },
  computed: {
    eid() {
      return this.$store.state.enterprise.enterpriseInfo.eid;
    },
    openMarket() {
      return this.$store.state.enterprise.enterpriseInfo.openMarket;
    },
    sidebar() {
      return this.$store.state;
    }
  },
  methods: {
    showExpiredTime(row) {
      if (row.expiredTime <= 0) {
        return '不过期';
      }
      return moment(new Date(row.createTime))
        .add(row.expiredTime, 'milliseconds')
        .format('YYYY-MM-DD HH:mm:ss');
    },
    getAccessKeyList(param) {
      this.listLoading = true;
      if (param) {
        this.listQuery = Object.assign(this.listQuery, param);
      }
      fetchAccessToken(Object.assign({}, this.listQuery, { eid: this.eid }))
        .then((re) => {
          this.accesskeys = re.accessKeys;
          this.listQuery.total = re.total;
          this.listLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.listLoading = false;
        });
    },
    createSuccess() {
      this.showAdd = false;
      this.getAccessKeyList();
    },
    deleteAccessKey(row) {
      this.$confirm('确认要删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAccessKeyApi({ eid: this.eid, accessKeyID: row.accessKeyID })
          .then((re) => {
            this.$message.success('删除成功');
            this.getAccessKeyList();
          })
          .catch((err) => {
            errorHandle(err);
          });
      });
    },
    updateAccessKey(row) {
      this.$confirm('更新后原来的AccessKey将不能使用，确认要更新吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateAccessKeyApi({
          eid: this.eid,
          accessKeyID: row.accessKeyID
        }).then((re) => {
          this.accessKey = re;
          this.showAdd = true;
        });
      });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/page-shell.scss';
</style>



// WEBPACK FOOTER //
// src/views/information/accesskey/index.vue